import React from 'react';

// Approach 1: Environment Variables
const envVersion = process.env.REACT_APP_VERSION;
const envBuildTime = process.env.REACT_APP_BUILD_TIME;

// Approach 3: Generated Version File
let fileVersion: any = {};
try {
  // Import will be available after build-time generation
  fileVersion = require('../version');
} catch (error) {
  // Version file not generated yet - use fallback values
  fileVersion = {
    VERSION: 'dev',
    BUILD_DATE: 'Development',
    GIT_COMMIT: 'local',
    VERSION_INFO: 'v1.0.0-dev',
    FULL_VERSION_INFO: 'v1.0.0-dev - Development - local'
  };
}

interface VersionInfoProps {
  mode?: 'simple' | 'detailed';
  className?: string;
}

const VersionInfo: React.FC<VersionInfoProps> = ({ 
  mode = 'simple', 
  className = '' 
}) => {
  // Use generated version info (Approach 3) as primary, env vars as fallback
  const versionDisplay = fileVersion.VERSION_INFO || `v${fileVersion.VERSION || envVersion || '1.0.0'}`;
  const fullVersionInfo = fileVersion.FULL_VERSION_INFO || versionDisplay;
  const buildInfo = fileVersion.BUILD_DATE || new Date(envBuildTime || Date.now()).toLocaleDateString();
  const gitCommit = fileVersion.GIT_COMMIT || 'unknown';

  if (mode === 'simple') {
    return (
      <span className={`version-info ${className}`} title={fullVersionInfo}>
        {versionDisplay}
      </span>
    );
  }

  return (
    <div className={`version-info-detailed ${className}`}>
      <div className="version-line">
        <strong>Version:</strong> {versionDisplay}
      </div>
      <div className="build-line">
        <strong>Build:</strong> {buildInfo}
      </div>
      <div className="commit-line">
        <strong>Commit:</strong> {gitCommit}
      </div>
    </div>
  );
};

// Alternative: Log version to console for developers
export const logVersionInfo = () => {
  console.group('🎨 Carousel SPA Version Info');
  console.log('Display:', fileVersion.VERSION_INFO || `v${fileVersion.VERSION || envVersion || '1.0.0'}`);
  console.log('Branch:', fileVersion.GIT_BRANCH || 'unknown');
  console.log('Build Date:', fileVersion.BUILD_DATE || 'Development');
  console.log('Build Time:', fileVersion.BUILD_TIME || envBuildTime || 'Unknown');
  console.log('Git Commit:', fileVersion.GIT_COMMIT || 'local');
  console.groupEnd();
};

export default VersionInfo;